import { FC } from 'react';
import { DeviceFunctionsView } from './device-functions-view';
import { DevicesView } from './devices-view';
import { FriendsFamilyQrView } from './friends-family-qr-view';
import { NotificationsView } from './notifications-view';
import { ResidentsView } from './residents-view';

export const ConfigurationPanel: FC = () => (
  <>
    <div className="pt-4">
      <DevicesView />
    </div>
    <div className="pt-14">
      <ResidentsView />
    </div>
    <div className="pt-14">
      <DeviceFunctionsView />
    </div>
    <div className="pt-14">
      <NotificationsView />
    </div>
    <div className="pt-14">
      <FriendsFamilyQrView />
    </div>
  </>
);
